var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-sm-8 col-sm-offset-2" }, [
    _c(
      "div",
      { staticClass: "well" },
      [
        _c("h4", [_vm._v("Comments: ")]),
        _vm._v(" "),
        _vm._l(_vm.comments, function(comment) {
          return comment.post == _vm.postId
            ? _c("div", { key: comment.id, staticClass: "comment" }, [
                _c("p", [_vm._v(_vm._s(comment.author_name) + " : ")]),
                _vm._v(" "),
                _c("p", {
                  domProps: { innerHTML: _vm._s(comment.content.rendered) }
                })
              ])
            : _vm._e()
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-20a72b50", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20a72b50","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/js/components/CommentList.vue
// module id = 409
// module chunks = 0